module.exports = __webpack_public_path__ + "static/media/site_solution.67794255.png";